import { CcRequirementParentChild } from "server/models"
import { GET, POST, DELETE } from "client/store/utils"


export const LoadAllCcRequirementParentChild = (projectId: number) => (
    GET(`/ccRequirementParentChild/projectId/${projectId}`)
    .then((connections: CcRequirementParentChild[]) => connections)
)

export const LoadCcRequirementParents = (requirementId: number) => (
    GET(`/ccRequirementParentChild/parents/requirementId/${requirementId}`)
    .then((connections: CcRequirementParentChild[]) => {
        const requirementIds: number[] = []
        connections.forEach((row) => {
            requirementIds.push(row.parentId)
        })
        return requirementIds
    })
)

export const LoadCcRequirementChildren = (requirementId: number) => (
    GET(`/ccRequirementParentChild/children/requirementId/${requirementId}`)
    .then((connections: CcRequirementParentChild[]) => {
        const requirementIds: number[] = []
        connections.forEach((row) => {
            requirementIds.push(row.childId)
        })
        return requirementIds
    })
)

export const CreateManyCcRequirementParentChild = (
    data: CcRequirementParentChild[],
) => (
    POST(
        "/ccRequirementParentChild/bulkCreate",
        JSON.stringify(data),
    )
)

export const DeleteCcRequirementParentChild = (parentId: number, childId: number) => (
    DELETE(`/ccRequirementParentChild/delete/parent/${parentId}/child/${childId}`)
    .then((removedRows: number) => removedRows)
)
